import styled from 'styled-components';

import colors from '../../styles/colors';

const ChatContainer = styled.div`
  max-width: 100%;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  background-color: ${colors.base.alpha};
`;

export {
  ChatContainer,
};
